import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.project.item');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-page-project-item',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/page.project.item/view.scss */
/* src/app/page.project.item/view.scss: no such file or directory */`],
})
export class PageProjectItemComponent implements OnInit, OnDestroy {
    public updating: boolean = false;
    public id: string = '';
    public tab: string = 'info';
    public data: any = null;
    public hosts: any = [];
    public ip_list: any = [];
    public role: any = 'visitor';
    public is_favorite: boolean = false;
    public ip_usage: any = {};
    public ownerInfo: any = null;
    public listPath: string = '/project';
    public sourceQuery: string = '';

    private basePath: string = '/project';
    private routerSub: any;
    private sourceGroupId: string = '';

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {
        this.id = WizRoute.segment.id;
        this.tab = WizRoute.segment.tab || 'info';
        this.syncReturnPath();
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newId = WizRoute.segment.id;
                const newTab = WizRoute.segment.tab || 'info';

                if (newId && newId !== this.id) {
                    this.setSourceGroupId(this.readSourceGroupId());
                    this.id = newId;
                    this.tab = newTab;
                    await this.load();
                } else if (newTab !== this.tab) {
                    this.syncReturnPath(this.data);
                    this.tab = newTab;
                    await this.service.render();
                }
            }
        });

        if (!WizRoute.segment.tab) {
            this.service.href(`${this.basePath}/${this.id}/info${this.sourceQuery}`);
            return;
        }

        await this.load();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public async load() {
        this.data = null;
        await this.service.render();

        if (this.id === 'new') {
            this.setSourceGroupId(this.readSourceGroupId());
            this.data = { name: '', category: '', group_id: this.sourceGroupId, params: [] };
            this.role = 'admin';
            this.ip_list = [];
            this.hosts = [];
            this.is_favorite = false;
            this.ip_usage = {};
            this.ownerInfo = null;
            await this.service.render();
            return;
        }

        const { code, data } = await wiz.call("get", { id: this.id });
        if (code !== 200) {
            this.service.href(this.listPath);
            return;
        }
        this.data = data.project;
        this.syncReturnPath(this.data);
        this.role = data.role;
        this.ip_list = data.ip_list;
        this.hosts = data.hosts;
        this.is_favorite = data.is_favorite;
        this.ip_usage = data.ip_usage || {};
        this.ownerInfo = data.owner_info || null;
        if (!this.data.params) this.data.params = [];
        await this.service.render();
    }

    public async toggleFavorite() {
        const { code, data } = await wiz.call("toggle_favorite", { id: this.id });
        if (code === 200) {
            this.is_favorite = data.is_favorite;
            await this.service.render();
        }
    }

    public async update() {
        await this.service.render(this.updating = true);

        let pd = JSON.stringify(this.data);
        const { data } = await wiz.call("update", { data: pd });

        await this.service.sleep(1000);

        if (!data.id) {
            await this.service.render(this.updating = false);
            return;
        }

        if (this.id != data.id) {
            this.id = data.id;
            this.data = data;
            this.syncReturnPath(this.data);
            this.service.href(`${this.basePath}/${this.id}/${this.tab}${this.sourceQuery}`);
        }

        await this.service.render(this.updating = false);
    }

    private readSourceGroupId() {
        const params = new URLSearchParams(window.location.search);
        return params.get('group') || '';
    }

    private setSourceGroupId(groupId: string = '') {
        this.sourceGroupId = groupId || '';
        this.listPath = this.sourceGroupId ? `/project-group/${this.sourceGroupId}/projects` : this.basePath;
        this.sourceQuery = this.sourceGroupId ? `?group=${encodeURIComponent(this.sourceGroupId)}` : '';
    }

    private syncReturnPath(project: any = null) {
        const routeGroupId = this.readSourceGroupId();
        const groupId = routeGroupId || (project ? project.group_id || '' : this.sourceGroupId);
        this.setSourceGroupId(groupId);
    }
}

export default PageProjectItemComponent;